'use client';

import { COOKIE_PREFIX, CookieName, dynamicWorkspaceSchema } from './const';

export function setCookie(name: CookieName, value: string, seconds?: number): void {
  if (!name) {
    return;
  }

  let expires = '';
  if (seconds) {
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000); // 밀리초로 변환
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${COOKIE_PREFIX}${name}=${encodeURIComponent(value || '')}${expires}; path=/`;
}

export function getCookie(name: CookieName): string | null {
  const nameEQ = `${COOKIE_PREFIX}${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

export function removeCookie(name: CookieName): void {
  document.cookie = `${COOKIE_PREFIX}${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

export function removeCookies(names: CookieName[]): void {
  names.forEach((name) => {
    removeCookie(name);
  });
}

export function removeWorkspaceTokenCookies() {
  const allCookies = document.cookie.split(';').map((c) => c.trim().split('=')[0]);
  const targetCookies = allCookies
    .filter((cookieName: CookieName) => {
      return dynamicWorkspaceSchema.safeParse(cookieName.replace(COOKIE_PREFIX, '')).success;
    })
    .map((cookie) => cookie.replace(COOKIE_PREFIX, ''));
  removeCookies(targetCookies as CookieName[]);
}
